import { useEffect, useState } from "react";
import { useAtomValue, useSetAtom } from "jotai";

import { userAtom } from "@/atoms/auth.atoms";
import { selfHostConnectionAtom } from "@/atoms/broadcastTarget.atoms";

/**
 * Listens for the "auth:session-expired" CustomEvent that api.ts dispatches
 * on any authenticated 401. Only surfaces the modal when a user was actually
 * logged in (a stray 401 during the logged-out state is not "expiry").
 */
export function useSessionExpiredListener(): boolean {
  const user = useAtomValue(userAtom);
  const setConnection = useSetAtom(selfHostConnectionAtom);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const handler = () => {
      setConnection(null);
      setExpired(true);
    };

    window.addEventListener("auth:session-expired", handler);
    return () => window.removeEventListener("auth:session-expired", handler);
  }, [setConnection]);

  // A fresh login clears the flag.
  useEffect(() => {
    if (user) setExpired(false);
  }, [user]);

  return expired && user !== null;
}
